import * as api from "api/Core";
import { AppMessageBox } from "components/AppMessageBox";
import DashDoughnutListBox, { DashDoughnutBoxListItem } from "components/Dashboard/DashDoughnutListBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import LibUtils from "lib/LibUtils";
import { DashboardKnowledgeIndicatorsGraphGroup, DashboardKnowledgeIndicatorsResumeModel, DashboardKnowledgeIndicatorsSummaryColumn, DashboardUserAndGroupsAndManagersBaseFilter } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    defaultGraphGroup: DashboardKnowledgeIndicatorsGraphGroup;
    activeTile: DashboardKnowledgeIndicatorsSummaryColumn;
    filter: DashboardUserAndGroupsAndManagersBaseFilter;
    onChange: (tile: DashboardKnowledgeIndicatorsSummaryColumn) => void;
}

interface IState {
    data: DashboardKnowledgeIndicatorsResumeModel;
    loading: boolean;
}

type Props = IProps & WithTranslation;

class KnowledgeTestIndicatorsTiles extends React.PureComponent<Props, IState>
{
    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
        };
    }

    ///
    private res(r: string) {
        return this.props.t("Views.Dashboards.KnowledgeTest.IndicatorsTiles." + r);
    }

    ///
    private loadData() {
        api.getDashboardKnowledgeTestIndicators(
            {
                defaultGraphGroup: this.props.defaultGraphGroup,
                columnToSummary: DashboardKnowledgeIndicatorsSummaryColumn.Resume,
                ...this.props.filter
            })
            .then((result: DashboardKnowledgeIndicatorsResumeModel) => {
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    ///
    private handleTileClick(tile: DashboardKnowledgeIndicatorsSummaryColumn) {
        this.props.onChange(tile);
    }

    ///
    private renderBoxes() {
        const { data, loading } = this.state;
        const { activeTile } = this.props;

        var boxes: DashDoughnutBoxListItem[] = [
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Knowledge,
                title: this.res("KnowledgeTitle"),
                value: loading ? null : data.knowledge,
                nullText: "N/D"
            },
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Result,
                title: this.res("ResultTitle"),
                value: loading ? null : data.result,
                nullText: "N/D"
            },
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Trust,
                title: this.res("TrustTitle"),
                value: loading ? null : data.trust,
                nullText: "N/D"
            },
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Completed,
                title: this.res("CompletedTitle"),
                value: loading ? null : data.completed,
                nullText: "N/D"
            },
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Revision,
                title: this.res("RevisionTitle"),
                value: loading ? null : data.revision,
                nullText: "N/D"
            },
            {
                key: DashboardKnowledgeIndicatorsSummaryColumn.Engagement,
                title: this.res("EngagementTitle"),
                value: loading ? null : data.engagement,
                nullText: "N/D"
            }
        ];

        return (
            <MuiContainer margin="normal">
                <DashDoughnutListBox
                    color="success"
                    boxes={boxes}
                    active={activeTile}
                    onClick={(key: DashboardKnowledgeIndicatorsSummaryColumn) => this.handleTileClick(key)}
                />
            </MuiContainer>
        );
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public componentDidUpdate(prevProps: Props) {
        if (!LibUtils.isEqual(prevProps.filter, this.props.filter)) {
            this.loadData();
        }
    }

    ///
    public render() {
        const { data, loading } = this.state;
        return (
            <MuiContainer margin="normal" >
                {
                    !loading && data == null
                        ? <AppMessageBox resource="LoadGraphDataFailed" />
                        : this.renderBoxes()
                }
            </MuiContainer>
        );
    }
}

export default withTranslation()(KnowledgeTestIndicatorsTiles);